const apiUrls = require('../../constants/apiUrls');

const customerDetails = {
    key: 'customerDetails',
    method: 'GET',
    getApiUrl: (request) => {
        return `${apiUrls.WORKORDER_CUSTOMER_INFO_URL}?billingSystem=${request.billingSystem}&accountNumber=${request.accountNumber}&houseNumber=${request.houseNumber}`;
    },
    dependencies: [
        {
            key: 'orderDetails',
            requestProps: [
                {
                    path: [
                        'details', 'accountNumber'
                    ],
                    propName: 'accountNumber'
                }
            ]
        }, {
            key: 'schedulingSystemDetails',
            requestProps: [
                {
                    path: [
                        'details', 'billingSystem'
                    ],
                    propName: 'billingSystem'
                }
            ]
        }, {
        key: 'schedulingSystemDetails',
        requestProps: [
          {
            path: [
              'details', 'addressInfo', 'addressId'
            ],
            propName: 'houseNumber'
          }
        ]
      }
    ]
};

export default customerDetails;



// WEBPACK FOOTER //
// ./src/store/order-details-config/customerDetails.js